import { useState } from "react";

import { CustomerOrderModel } from "@/api/mappers/customerOrderList.mapper";
import { Pagination } from "@/components/General/Pagination/pagination.container";
import { formatISO } from "@/utils/date";
import { formatPrice } from "@/utils/price.utils";

import { CUSTOMER_ORDER_LIST_PAGE_SIZE } from "./hooks/useOrderList.hook";
import Order from "./Order/order.component";
import OrderSummary from "./OrderSummary/orderSummary.component";

import "./orderList.scss";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    orders: Array<CustomerOrderModel>;
    totalNumberOfHits: number;
    totalPages: number;
    loading: boolean;
    loadNextPage: () => void;
};

const OrderList = ({
    orders,
    totalNumberOfHits,
    totalPages,
    loading,
    loadNextPage
}: Props) => {
    const { t } = useGranite();

    const [activeId, setActiveId] = useState<null | string>(null);

    return (
        <div>
            {orders.map((order) => (
                <div
                    key={order.id}
                    className="orderList"
                >
                    <OrderSummary
                        id={order.id}
                        creationDate={formatISO(order.creationDate)}
                        totalPrice={formatPrice(order.totalPrice, {
                            freeLabel: true,
                            currency: true,
                            t: t
                        })}
                    />
                    <Order
                        activeId={activeId}
                        orderId={order.id}
                        setActive={setActiveId}
                        order={order}
                    />
                </div>
            ))}
            {totalPages > 1 && (
                <Pagination
                    className={"mt-3"}
                    currentNumberOfHits={orders.length}
                    totalNumberOfHits={totalNumberOfHits}
                    hitsPerPage={CUSTOMER_ORDER_LIST_PAGE_SIZE}
                    loading={loading}
                    onLoadMore={loadNextPage}
                />
            )}
        </div>
    );
};

export default OrderList;
